// src/websocket.js
import Vue from 'vue'
import { cardReaderStatus } from './utils/cardReaderStatus'
export const EventBus = new Vue()

let socket = null;

export function initWebSocket(url, registerMessage = null) {
  cardReaderStatus.setConnecting()
  socket = new WebSocket(url);

  socket.onopen = () => {
    console.log('WebSocket 已连接')
    EventBus.$emit('ws-open', true)

    // 如果提供了注册消息，连接后立即发送
    if (registerMessage) {
      socket.send(registerMessage)
    //   console.log('发送注册消息：', registerMessage)
    }
  };

  socket.onmessage = (event) => {
    // console.log('收到消息：', event.data)
    EventBus.$emit('ws-message', event.data)
  };

  socket.onclose = () => {
    // console.log('WebSocket 已关闭')
    EventBus.$emit('ws-close', true)
  };

  socket.onerror = (error) => {
    // console.error('WebSocket 出错：', error)
    EventBus.$emit('ws-error', error)
  };
}

export function isWebSocketOpen() {
  return !!(socket && socket.readyState === WebSocket.OPEN)
}

export function sendMessage(message) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(message)
    return true
  }
  console.warn('WebSocket 未连接')
  return false
}

export function closeWebSocket() {
  if (socket) {
    socket.close()
  }
}
